import type { ClientProps } from '@pages/Invoicing/context/types'
import type { FiliDataProps } from '@hooks/useUser/types'
import type { AddEditOtherServicesModalFormProps } from '../form/types'

export interface MapSubmitOtherServicesFormValuesProps {
  clientData?: ClientProps | null
  filiData: FiliDataProps | null
  formData: AddEditOtherServicesModalFormProps
}

export const mapSubmitOtherServicesFormValues = ({
  clientData,
  filiData,
  formData
}: MapSubmitOtherServicesFormValuesProps) => {
  formData.filiCode = filiData?.filiCode || ''
  formData.clientCode = clientData?.cdClienteNl || formData.clientCode || ''
  formData.competenceDate = filiData?.startPeriod || ''

  return formData
}
